module.exports = __webpack_public_path__ + "img/11passenger_stopped.d7a65cf0.svg";